"use client";
import Footer from "@/components/Footer";
import HeaderAuth from "@/components/Header/AppBarAuth";
import ThemeRegistry from "@/components/Theme/ThemeRegistry";
import { Box } from "@mui/material";
import clsx from "clsx";
import React from "react";

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <ThemeRegistry>
      <HeaderAuth />
      <Box
        className={clsx(
          "flex justify-start items-center flex-col bg-gradient-to-b from-[#E9F2FB] via-[#E9F2FB] to-[#F7FAEA] md:min-h-screen"
        )}
      >
        <Box className="flex justify-center w-full sm:w-auto md:pt-14 pb-2 md:pb-6">
          <Box className="w-full md:w-[496px] p-6 md:p-12 md:shadow-[0px_2px_16px_0px_rgba(0,0,0,0.10)] bg-white md:rounded-[4px] relative">
            <Box className="flex flex-col max-w-[400px] mx-auto">
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
      <Footer />
    </ThemeRegistry>
  );
};

export default Wrapper;
